import React, { Component } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import TopButton from "../../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import "./Error.css";
import { Link } from "react-router-dom";

export default class Error extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="error-main">
        <Header theme={this.props.theme} />
        <div className="error-class">
          <Fade bottom duration={2000} distance="40px">
      {/*
            <h1>Woops</h1>
            <h1 className="error-404">404 Yes Finf abouy me</h1>
            <p>The requested page is unavailable at the moment!</p>
     */}
          <h4 className="error-404"> Congratulations You Have Reached Here.</h4>
  
            <p>I am a technology fanatic by professional and technical architect.</p> <p>let's discuss the intent behind creating a web application and the modern tech stacks.</p>
            
            <Link
              className="main-button"
              to="/home"
              style={{
                color: theme.body,
                backgroundColor: theme.text,
                border: `solid 1px ${theme.text}`,
                display: "inline-flex",
              }}
            >
              Go Home
            </Link>
          </Fade>
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}
